import { Box } from "@compass/core";
import { DefaultExtensionType, FileIcon as ReactFileIcon, defaultStyles } from "react-file-icon";

export const FileIcon = (props: { fileName: string | undefined; size?: "small"; height?: string }) => {
  const extension: string | undefined = props.fileName?.split(".").pop();

  if (!extension) {
    return null;
  }

  let width: string = "100%";

  if (props.size === "small") {
    width = "30px";
  }

  return (
    <Box display="inline-flex" width={width} height={props.height}>
      <ReactFileIcon extension={extension} {...defaultStyles[extension as DefaultExtensionType]} />
    </Box>
  );
};
